export enum AlertType {
    Success = 'success',
    Error = 'danger',
    Info = 'info',
    Warning = 'warning'
}

export interface Alert {
    type: AlertType;
    message: string;
    dismissible: boolean;
    dismissOnTimeout: number;
}